import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-opensea.svg'
import _imports_1 from '@/assets/images/icon-looksrare.svg'


const _withScopeId = n => (_pushScopeId("data-v-25d06a1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "platform-links-container"
}
const _hoisted_2 = ["data-network", "data-address"]
const _hoisted_3 = { class: "platform-links" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]

import { useBR } from '@/composables/useBR';
import { useInjectTopLevelProps } from '@/exports/MBurnRedeemCompleteWidgetProps';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformLinks',
  setup(__props) {

const { network } = useInjectTopLevelProps();
const { redeemContractAddress } = useBR();

return (_ctx: any,_cache: any) => {
  return (_unref(redeemContractAddress))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          id: "restricted-token",
          "data-widget": "m-restricted-token",
          "data-network": _unref(network),
          "data-address": _unref(redeemContractAddress)
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            target: "_blank",
            href: `https://${_unref(network) === 5 ? 'testnets.' : ''}opensea.io/assets/${
          _unref(network) === 5 ? 'goerli' : 'ethereum'
        }/${_unref(redeemContractAddress)}`
          }, _hoisted_6, 8, _hoisted_4),
          _createElementVNode("a", {
            target: "_blank",
            href: `https://${_unref(network) === 5 ? 'goerli.' : 'www.'}looksrare.org/collections/${
          _unref(redeemContractAddress)
        }`
          }, _hoisted_9, 8, _hoisted_7)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})